"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingCoreTransferPerformModeEnum = void 0;
/**
 * Режим срабатывания трансфера
 */
var BillingCoreTransferPerformModeEnum;
(function (BillingCoreTransferPerformModeEnum) {
  /** После создания */
  BillingCoreTransferPerformModeEnum["AFTER_CREATE"] = "AFTER_CREATE";
  /** В любое время вызовом соотвествующего метода */
  BillingCoreTransferPerformModeEnum["MANUAL"] = "MANUAL";
  /** При успешной оплате начисления */
  BillingCoreTransferPerformModeEnum["CHARGE_PAID"] = "CHARGE_PAID";
  /** В запланированную дату и время */
  BillingCoreTransferPerformModeEnum["SCHEDULED"] = "SCHEDULED";
})(BillingCoreTransferPerformModeEnum = exports.BillingCoreTransferPerformModeEnum || (exports.BillingCoreTransferPerformModeEnum = {}));
